import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SEO, PHOTOS } from "@/data/site";

const OG_IMAGE = PHOTOS.pallavi;

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSEO() {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = SEO[pathname] || SEO["/"];
    const url = `${window.location.origin}${pathname}`;

    document.title = meta.title;
    upsertMeta("name", "description", meta.description);

    // Canonical
    upsertLink("canonical", url);

    // Open Graph
    upsertMeta("property", "og:title", meta.title);
    upsertMeta("property", "og:description", meta.description);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", OG_IMAGE);
    upsertMeta("property", "og:site_name", "Dr. Pallavi Mishra — Cardiologist Varanasi");
    upsertMeta("property", "og:locale", "en_IN");

    // Twitter
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", meta.title);
    upsertMeta("name", "twitter:description", meta.description);
    upsertMeta("name", "twitter:image", OG_IMAGE);
  }, [pathname]);
}
